import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export default class Canvas extends React.Component {
  render() {
    const { spanClass, spacing, children } = this.props;

    const rowClasses = classnames('row', { spacing });

    return (
      <div className="canvas">
        <div className="containerwrapper">
          <div className="container">
            <div className={ rowClasses }>
              <div className={ spanClass }>
                { children }
              </div>  
            </div>    
          </div>
        </div>
      </div>
    );
  }
}

Canvas.propTypes = {
  spanClass: PropTypes.string,
  spacing: PropTypes.bool,
};

Canvas.defaultProps = {
  spacing: true
}



// WEBPACK FOOTER //
// ./src/components/Canvas.js